const yup = require("yup");

export const allocationCodeRequiredIfType = (
  field = "allocationType",
  key = "key",
) =>
  function (value) {
    const context = this.options.context || {};
    const allocationType = context[field];
    if (allocationType && allocationType[key]) {
      return !!(value && value.id);
    }
    return true;
  };

const allocationValidation = yup.object().shape({
  allocationType: yup.object().shape({
    key: yup.string().required("Allocation Type is required"),
    name: yup.string().required("Allocation Type is required"),
  }),
  allocationCode: yup.string().required("allocation Code is required"),
});

export default allocationValidation;
